import { INIT_EXTENSION__object_static } from '@shared/extensions/EXTENSION__object_static';
import { enableMapSet } from 'immer';

enableMapSet(); // Enable the MapSet plugin at the very beginning app start
INIT_EXTENSION__object_static();

/*
 *
 */

import '@shared/extensions/extension_array';
import '@shared/extensions/extension_map';
import '@shared/extensions/extension_number';
import '@shared/extensions/extension_set';
import '@shared/extensions/extension_string';

/*
 *
 */

import '@/extensions/extension__fabric';
import '@/extensions/extension_canvas';
import '@/extensions/extension_import_meta';
import '@/extensions/extension_offscreen_canvas';
import '@/extensions/extension_performance_memory';
import '@/extensions/extension_window';
import '@/extensions/extention_svg_props';

import { FN_INIT__extensions_shared } from '@shared/_extensions/FN_INIT__extensions_shared';

import '@/pages/page_open_pose/extension/extension_object_3d';

import { init_redux_persist_store } from './state/store'; //import redux first to avoid circular dependency

import { assert_not_null_return } from '@shared/asserts/utils_asserts';
import { FN_INIT__class_mapping } from '@shared/serialization/FN_INIT__class_mapping';
import { log_app_version } from '@shared/utils/utils_logs';
import ReactDOM from 'react-dom/client';
import { init_constants_client } from './constants/init_constants_client';
import { init_loggers_local } from './logger/init_loggers_local';
import { init_loggers_remote } from './logger/init_loggers_remote';
import { load_open_pose_fbx_models } from './pages/page_open_pose/fbx/load_open_pose_fbx_models';
import { init_i18n } from './services/i18n/i18n';
import { validate_redux_actions } from './state/_base/validate_redux_actions';

import '@xyflow/react/dist/style.css';

import './tailwind.css';

import './index.css';

import 'cropperjs/dist/cropper.css';
import 'react-image-crop/dist/ReactCrop.css';
import { CONSTANTS__environment_client } from './constants/CONSTANTS__environment_client';
import { INIT_EXTENSION__graph_instance_client } from './extensions/INIT_EXTENSION__graph_instance_client';
import { INIT_EXTENSION__meta_image_use_client } from './extensions/INIT_EXTENSION__meta_image_use_client';
import { PROVIDER__store_redux } from './routes/PROVIDER__store_redux';

//need to avoid IDE error
declare const __APP_VERSION__: string;

async function main_client() {
  /*
   * EXTENSIONS
   */
  FN_INIT__extensions_shared();

  INIT_EXTENSION__graph_instance_client();
  INIT_EXTENSION__meta_image_use_client();

  /*
   *
   */

  init_loggers_local();

  init_constants_client();

  init_loggers_remote();

  log_app_version(__APP_VERSION__, CONSTANTS__environment_client.VITE_APP_BUILD_TIME, CONSTANTS__environment_client.VITE_APP_BUILD_TIMESTAMP_NUMBER);

  void load_open_pose_fbx_models();

  await init_i18n();

  FN_INIT__class_mapping();

  init_redux_persist_store();

  validate_redux_actions();

  let html_tag: HTMLElement = assert_not_null_return(document.getElementById('root'));

  const root = ReactDOM.createRoot(html_tag);

  root.render(<PROVIDER__store_redux />);
}

void main_client();
